document.addEventListener('DOMContentLoaded', function() {
  // Accordion functionality
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  // Open the first accordion item by default
  const firstHeader = accordionHeaders[0];
  if (firstHeader) {
    const firstContent = firstHeader.nextElementSibling;
    firstHeader.classList.add('active');
    firstContent.classList.add('active');
  }

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      // Close all other accordion items
      accordionHeaders.forEach(otherHeader => {
        if (otherHeader !== header) {
          otherHeader.classList.remove('active');
          otherHeader.nextElementSibling.classList.remove('active');
        }
      });

      // Toggle current item
      this.classList.toggle('active');
      const content = this.nextElementSibling;
      content.classList.toggle('active');
    });
  });

  // Live View Counter
  class LiveViewCounter {
    constructor(element) {
      this.element = element;
      this.min = parseInt(element.dataset.min);
      this.max = parseInt(element.dataset.max);
      this.interval = parseInt(element.dataset.interval) * 1000;
      this.message = element.dataset.message;
      this.countElement = element.querySelector('.live-view-count');
      this.textElement = element.querySelector('.live-view-text');
      this.currentCount = this.getRandomCount();
      
      this.init();
    }
    
    getRandomCount() {
      let count = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
      
      if (this.currentCount) {
        const change = Math.floor(Math.random() * 3) + 1;
        const direction = Math.random() > 0.5 ? 1 : -1;
        count = this.currentCount + (change * direction);
        count = Math.max(this.min, Math.min(this.max, count));
      }
      
      return count;
    }
    
    updateCount() {
      const newCount = this.getRandomCount();
      const difference = newCount - this.currentCount;
      const duration = 1000;
      const startTime = performance.now();
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentDisplayCount = Math.floor(this.currentCount + (difference * easedProgress));
        
        this.countElement.textContent = currentDisplayCount;
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.currentCount = newCount;
        }
      };
      
      requestAnimationFrame(animate);
    }
    
    init() {
      this.countElement.textContent = this.currentCount;
      setInterval(() => this.updateCount(), this.interval);
    }
  }

  // Sold Product Counter
  class SoldProductCounter {
    constructor(element) {
      this.element = element;
      this.soldData = [8,10,12,15,17,22]; // Default sold numbers
      this.hoursData = [10,12,15,16,18,20,24]; // Default hour ranges
      this.messageTemplate = "{sold} sold in last {hours} hours"; // Default message
      this.updateInterval = 900000; // 15 minutes
      
      // Initialize with default values
      this.currentSold = 10;
      this.currentHours = 18;
      
      this.init();
      this.startAutoUpdate();
    }
    
    getRandomValue(array) {
      return array[Math.floor(Math.random() * array.length)];
    }
    
    updateCounter() {
      this.currentSold = this.getRandomValue(this.soldData);
      this.currentHours = this.getRandomValue(this.hoursData);
      
      const message = this.messageTemplate
        .replace('{sold}', `<span class="highlight">${this.currentSold}</span>`)
        .replace('{hours}', `<span class="highlight">${this.currentHours}</span>`);
      
      this.element.innerHTML = message;
    }
    
    startAutoUpdate() {
      setInterval(() => this.updateCounter(), this.updateInterval);
    }
    
    init() {
      this.updateCounter();
    }
  }

  // Initialize counters
  document.querySelectorAll('live-view').forEach(element => {
    new LiveViewCounter(element);
  });

  document.querySelectorAll('sold-product').forEach(element => {
    new SoldProductCounter(element);
  });

  // Recently viewed products
  const currentProductHandle = "{{ product.handle }}";
  let viewedProducts = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  // Remove if already exists to avoid duplication
  viewedProducts = viewedProducts.filter(handle => handle !== currentProductHandle);

  // Add current product at the end
  viewedProducts.push(currentProductHandle);

  // Save back to localStorage
  localStorage.setItem('recentlyViewed', JSON.stringify(viewedProducts));
});